import { Text } from 'rebass';
import { Link as RouterLink } from 'react-router-dom';
import { styles } from './homeStyles';
import { useState } from 'react';

const ToolItem = ({ description, link, label, night }) => {
  const [hover, setHover] = useState(false);

  const cardStyle = {
    ...styles.toolCard(night),
    transform: hover ? 'translateY(-3px)' : 'translateY(0)',
    boxShadow: hover
      ? '0 8px 24px rgba(16,24,40,0.08)'
      : styles.toolCard(night).boxShadow
  };

  return (
    <div style={styles.toolItem}>
      <Text mb={2} style={styles.toolText}>
        {description}
      </Text>
      <RouterLink
        to={link}
        style={{ ...styles.toolLink, ...cardStyle }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {label}
      </RouterLink>
    </div>
  );
};

export default ToolItem;
